import React from 'react';

const BS_ThemeCompany = () => {
    return (
        <div>
            <h1>BS_ThemeCompany Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_ThemeCompany;
